import React from 'react'
import { Formik, Form } from 'formik'
import {
  InputField,
  InputSelectOptions,
  LoaderButton
} from 'components/molecules'
import { IS_STANDALONE } from 'domains/product-collection/constants'
import productCollectionScheme from './product-collection-create-scheme'
import StringUtil from 'utils/string-util'
import PropTypes from 'prop-types'

const propTypes = {
  selectedItems    : PropTypes.array,
  NewItemsTable    : PropTypes.func,
  handleSubmitForm : PropTypes.func,
  isSubmitting     : PropTypes.bool
}

const defaultProps = {
  selectedItems    : [],
  NewItemsTable    : () => {},
  handleSubmitForm : () => {},
  isSubmitting     : false
}

const ProductCollectionCreateForm = ({
  selectedItems,
  NewItemsTable,
  handleSubmitForm,
  isSubmitting
}) =>  {

  const handleChangeName = (event, formik) => {
    const value = event.target.value
    formik.setFieldValue('name', value)
    const urlName = StringUtil.transformToUrl(value)
    formik.setFieldValue('url', urlName)
  }

  return (
    <Formik
      enableReinitialize={ true }
      initialValues={{
        name               : '',
        url                : '',
        is_standalone_page : '',
        items              : selectedItems.map((item) => item.id)
      }}
      validationSchema={ productCollectionScheme }
      onSubmit={ handleSubmitForm }
    >
      {
        (formik) => (
          <Form>
            <div className='d-flex'>
              <div className='flex-grow-1 pr-3'>
                <InputField
                  type='text'
                  name='name'
                  label='Collection Name'
                  required={ true }
                  formText='Url field will change when you fill this field up.'
                  onChange={ (event) => {
                    formik.handleChange(event)
                    handleChangeName(event, formik)
                  } }
                />
                <InputField
                  name='url'
                  label='Url'
                  type='text'
                  required={ true }
                />
              </div>
              <div className='pl-3'>
                <InputField
                  name='is_standalone_page'
                  label='Is Standalone Page?'
                  type='select'
                  required={ true }
                >
                  <InputSelectOptions
                    options={ IS_STANDALONE }
                    keyPrefix='refund-method'
                  />
                </InputField>
              </div>
            </div>
            <NewItemsTable selectedItems={ selectedItems } />
            <LoaderButton
              className='float-right'
              isLoading={ isSubmitting }
              block={ false }
              color='success'
              type='submit'
              text="SUBMIT"
            />
          </Form>
        )
      }
    </Formik>
  )
}

ProductCollectionCreateForm.propTypes    = propTypes
ProductCollectionCreateForm.defaultProps = defaultProps

export default ProductCollectionCreateForm
